import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function ContactForm() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="contact" className="py-24 md:py-32 container mx-auto px-6 md:px-12" data-id="element-36">
      <div className="max-w-2xl mx-auto" data-id="element-37">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-38">
          <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-39">
            Book Your <span className="text-gold italic" data-id="element-40">Experience</span>
          </h2>
          <p className="text-white/60 font-light" data-id="element-41">
            Leave us your details and we'll get in touch to schedule your
            appointment.
          </p>
          <div className="w-24 h-[1px] bg-gold mx-auto mt-6" data-id="element-42"></div>
        </motion.div>

        <motion.div className="glass-card rounded-sm p-8 md:p-12" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} data-id="element-43">
          {submitted ? <motion.div className="text-center py-8" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5
        }} data-id="element-44">
              <div className="text-gold text-5xl mb-4" data-id="element-45">✓</div>
              <h3 className="font-serif text-2xl mb-3" data-id="element-46">Thank You!</h3>
              <p className="text-white/60 font-light" data-id="element-47">
                We'll be in touch with you shortly.
              </p>
            </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-48">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-49">
                <div data-id="element-50">
                  <label className="block text-xs tracking-[0.15em] uppercase text-white/50 mb-2 font-medium" data-id="element-51">
                    First Name
                  </label>
                  <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required className="w-full bg-white/5 border border-white/10 rounded-sm px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-gold/50 focus:bg-white/8 transition-all font-light" placeholder="Your first name" data-id="element-52" />
                </div>
                <div data-id="element-53">
                  <label className="block text-xs tracking-[0.15em] uppercase text-white/50 mb-2 font-medium" data-id="element-54">
                    Last Name
                  </label>
                  <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required className="w-full bg-white/5 border border-white/10 rounded-sm px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-gold/50 focus:bg-white/8 transition-all font-light" placeholder="Your last name" data-id="element-55" />
                </div>
              </div>
              <div data-id="element-56">
                <label className="block text-xs tracking-[0.15em] uppercase text-white/50 mb-2 font-medium" data-id="element-57">
                  Email
                </label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full bg-white/5 border border-white/10 rounded-sm px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-gold/50 focus:bg-white/8 transition-all font-light" placeholder="you@email.com" data-id="element-58" />
              </div>
              <div data-id="element-59">
                <label className="block text-xs tracking-[0.15em] uppercase text-white/50 mb-2 font-medium" data-id="element-60">
                  Phone
                </label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required className="w-full bg-white/5 border border-white/10 rounded-sm px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-gold/50 focus:bg-white/8 transition-all font-light" placeholder="(555) 000-0000" data-id="element-61" />
              </div>
              <div className="pt-4 flex justify-center" data-id="element-62">
                <Button type="submit" className="w-full md:w-auto" data-id="element-63">
                  Submit Request
                </Button>
              </div>
            </form>}
        </motion.div>
      </div>
    </section>;
}